import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import dataanalysis from "../../Assets/Projects/dataanalysis.png";
import basicmusicplayer from "../../Assets/Projects/basicmusicplayer.png";
import studentportal from "../../Assets/Projects/studentportal.png";
import employeemgmt from "../../Assets/Projects/employeemgmt.png";
import restaurantrec from "../../Assets/Projects/restrorec.png";
import googlecloud from "../../Assets/Projects/googlecloud.png";
import socialmedia from "../../Assets/Projects/socialmedia.png"
import TodoList from "./ToDoList";
import CountryStateDropdown from  "./CountryStateDropdown"

function Projects() {

  //Count increase and decrease
  const [count, setCount] = useState(0);

  function increase() {
    setCount(count + 1);
  }

  function decrease() {
    setCount(count - 1);
  }

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

         <Col md={4} className="project-card">
            <ProjectCard
              imgPath={socialmedia}
              isBlog={false}
              title="Social Media Website"
              description=<ui>
              <li>Developed a Dynamic Social Media Website with
              MongoDB, Express, React, NodeJS and Material UI .</li>
              <li>Users can login into their personal account and can Add/Remove friends, Upload Photos, Like, Comment and share their Posts .</li>
              <li>Used JWT token for API authentication .</li>
              <li>Integrated Dark Mode to reduce eye strain .</li>
              <br></br>
              </ui>
              ghLink="https://github.com/rushabhpanbude/social-media-website"
              viewDeployment="https://social-media-stack-git-prod-vercel-stack-rushabhpanbude.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={employeemgmt}
              isBlog={false}
              title="Employee Management"
              description=<ui>
              <li>Build a fully functional Management Website using
              Java, Angular (TypeScript), MySQL and Springboot .</li>
              <li>Used Postman for managing and testing API’s</li>
              <li>Microservices features Add, Delete, Update, Search for Employee data .</li>
              <li>Hosted on Aamazon Web Services : EC2, RDS and S3 .</li>
              </ui>
              ghLink="https://github.com/rushabhpanbude/Employee-Management-Web-Application"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={studentportal}
              isBlog={false}
              title="Student Study Portal"
              description=<ui>
              <li>Constructed and Hosted Full Stack Web Application
              using Python , JavaScript , Django (Rest API) & SQLlite .</li>
              <li>Developed features like Login&Password, Notes App
              To Do App , Dictionary App and Calculator App .</li>
              <li>Train, Test and Deployed superwised Machine Learning model to predict the percentage of student with respect to study hours .</li>
              <li>Integrated Google Books , Youtube & Wikipedia API .</li>
              </ui>
              ghLink="https://github.com/rushabhpanbude/student-study-portal"
              // viewDeployment="https://student-study-portal-njqdxbp52-rushabhpanbude.vercel.app" 
              viewDeployment="https://enchantic.pythonanywhere.com"
                          
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dataanalysis}
              isBlog={false}
              title="Exploratory Data Analysis"
              description=<ui>
              <li>Analyse California housing data by performing EDA with the help of Pandas profiling library.</li>
              <li>Visualize and Generated Report in html extension .</li>
              <li>Help's to identify obvious errors, as well as better understand patterns within the data, find interesting relations among the variables .</li>
              </ui> 
              ghLink="https://github.com/rushabhpanbude/DataAnalysis_1"
             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={googlecloud}
              isBlog={false}
              title="Google Cloud Platform"
              description=<ui>
              <li>Set up Virtual Machine and run OS(Ubuntu) in it.
              Stores data in objects inside Buckets, used BigQuery .</li>
              <li>Hosted a Minecraft server on Google Cloud with
              automatic deployment and backup .</li>
              <li>Created Docker image for Flask application, deployed
              it in Kubernetes and hosted publicly on the web.</li>
              </ui>
              certificate="https://www.coursera.org/account/accomplishments/professional-cert/NL7TVZWQL5DF"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={restaurantrec}
              isBlog={false}
              title="Restaurant Recommendation"
              description=<ui>
              <li>A Data Science project to solve a Business Case by recommending best city to start the Restaurant.</li>
              <li>Used Foursquare API to get the data and Folium library to visualize the map.</li>
              <li>Applied K-means Clustering to predict the location.</li>
              </ui>
              ghLink="https://github.com/rushabhpanbude/Coursera-Capstone"
            
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={basicmusicplayer}
              isBlog={false}
              title="Basic Music Player"
              description=<ui>
              <li>Build a basic Music Player Web Application using Vanilla JavaScrit .</li>
              <li>Functionable to Play, Pause, Play next, Play preavious, Volume increase & decrease .</li>
              <li>Fully Responsive at any resolution .</li>
              </ui>
              ghLink="https://github.com/rushabhpanbude/basic-music-player"              
              viewDeployment="https://rushabhpanbude.github.io/basic-music-player/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <div className="project-card-view card">
              <div style={{padding: "20px"}}>
                <div>
                  <h2>Counter</h2>
                    <div className="counter-inline">
                     <button className="project-btn" onClick={decrease}>-</button>
                     <h1 className="m-0">{count}</h1>
                     <button className="project-btn" onClick={increase}>+</button>
                    </div>
                </div>
                <hr></hr>
                <TodoList />
                
                <hr></hr>
                <CountryStateDropdown />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;